module.exports = __webpack_public_path__ + "static/media/bohemiaLogo.476e056e.png";